import React from 'react';
import {
    useOrderExpectedAt,
    isOrderExpectedTomorrow,
    isOrderExpectedToday,
} from '@/hooks/api/order';

const OrderDateLabel = () => {
    const expected_at = useOrderExpectedAt();
    let string = '';

    if (
        !expected_at ||
        (!isOrderExpectedToday() && !isOrderExpectedTomorrow())
    ) {
        string = '';
    } else {
        string = expected_at.format('ddd, Do MMM');
    }

    return (
        <div
            data-order-date-alternate-display
            className="m2g-order-date-alternate-display m2g-text--small m2g-text--offset"
        >
            {string}
        </div>
    );
};

export default OrderDateLabel;
